import { render, staticRenderFns } from "./PlayersTable.vue?vue&type=template&id=267da5fe&lang=html&"
import script from "./PlayersTable.vue?vue&type=script&lang=js&"
export * from "./PlayersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports